import React, { useState } from 'react';
import { Box, Flex } from '@lightspeed/flame/Core';
import { Autocomplete } from '../fields';
import { Text } from '@lightspeed/flame/Text';
import { Label } from '@lightspeed/flame/FormField';
import { useGetLocationsQuery } from '../../services/dashboardService';
import { useTranslation } from 'react-i18next';
import useConnectionMode from '../../hooks/useConnectionMode';
import { SwitchLayout } from '../custom/SwitchLayout';
import { useEffect } from 'react';
import { useNotification } from '../../utils/helpers/notifications';

export const MultipleClass = ({ formik }) => {
    const { isMapClass, locations, classes } = formik.values;
    const [, swName] = useConnectionMode();
    const { t } = useTranslation();

    const { data: classList, isFetching: fetchingClass, isLoading: loadingClass } = useGetLocationsQuery({ class: true }, { skip: !isMapClass ?? true })
    const { data: locationsList, isFetching: fetchingLocation, isLoading: loadingLocation } = useGetLocationsQuery({ class: false }, { skip: !isMapClass ?? true })

    const isLoading = fetchingClass || fetchingLocation || loadingClass || loadingLocation

    const { showNotification } = useNotification()

    useEffect(() => {
        if ((classList && classList?.length === 0) && !(locations && locations !== '')) {
            showNotification('Class not enabled in accounting software', 'error');
        }

        if (locationsList && locationsList?.length === 0 && !(classes && classes !== '')) {
            showNotification('Location not enabled in accounting software', 'error');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classList])

    return (
        <SwitchLayout
            heading={t('Location tracking', { swName })}
            description={t('ClassMappingKSeries', { swName })}
            switchFieldName="isMapClass"
            isSwitchOn={isMapClass}
            isLoading={isLoading}
        >
            <Flex>
                <Box width="49%" pr="1.1rem">
                    <Label htmlFor="locationMapping">
                        {t('Select a Location')}
                    </Label>
                    <Autocomplete
                        id="locationMapping"
                        name="locations"
                        isLoadingOptions={!classList || isLoading}
                        options={locationsList}
                        disabled={classes && classes !== ''}
                        placeholder={t('Select a location')}
                        formik={formik}
                    />
                </Box>
                <Box width="49%" pr="1.1rem">
                    <Label htmlFor="classMapping">
                        {t('Select a Class')}
                    </Label>
                    <Autocomplete
                        id="classMapping"
                        name="classes"
                        isLoadingOptions={!classList || isLoading}
                        disabled={locations && locations !== ''}
                        options={classList}
                        placeholder={t('Select a class')}
                        formik={formik}
                    />
                </Box>
            </Flex>
            <Flex mt="1rem" ml=".2rem">
                <><Text fontWeight={"bold"} mr=".3rem">Required : </Text> Either Location mapping or Class Mapping.</>
            </Flex>
        </SwitchLayout>
    )
}